define('home/utils/features',[
    'modernizr',
], function (
    Modernizr
) {
    'use strict';

    var defines = {
        browser: {
            // Modified from:
            // http://stackoverflow.com/questions/3514784/best-way-to-detect-handheld-device-in-jquery
            // Note: includes tablets
            mobile:
                /iPhone|Android|iPod|iPad|webOS|Mobile Safari|Windows Phone|BlackBerry|Opera Mini|IEMobile/i.test(window.navigator.userAgent),
        },
    };

    var canUseContentEditable = Modernizr.contenteditable &&
        !defines.browser.mobile &&
        !(window.opera && window.opera.version);


    return {
        canUseContentEditable: function () {
            return canUseContentEditable;
        },
    };
});

